import type { RadarComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, widgetDatePatch } from "./_shared";

// Date range only — radar subjects live per-series (subjectFilter) and are left untouched.
export const radarControlPanel: ControlPanelHandler<RadarComponentSpec> = (spec, patch) => {
  spec.radar_builder_misc = {
    ...spec.radar_builder_misc,
    ...(patch.applyDate && !isBound(spec.radar_builder_misc, "date", patch) && widgetDatePatch(patch.date)),
  };
};
